<template>
  <div class="outstock">
        <div class="search">
          <el-input v-model="devicecode" placeholder="设备编码"></el-input>
          <el-select v-model="value" placeholder="请选择" @change="selectuse">
            <el-option label="全部" value="2"></el-option>
            <el-option label="未使用" value="0"></el-option>
            <el-option label="已使用" value="1"></el-option>
        </el-select>
            <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
      </div>
      <div class="listbtn">
          <el-button  v-preventReClick type="primary" @click="returns()">退货</el-button>
      </div>
      <div class="tablelist">
          <el-table
            :data="tableData"
            :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
            type="selection"
            width="55">
            </el-table-column>
            <el-table-column
                prop="deviceId"
                label="设备ID"
                width="120">
            </el-table-column>
            <el-table-column
                prop="deviceName"
                label="设备名称"
                width="150">
            </el-table-column>
            <el-table-column
                prop="deviceCoding"
                width="250"
                label="设备编码">
            </el-table-column>
            <el-table-column
                prop="useState"
                width="180"
                label="使用状态">
                <template slot-scope="scope">
                    {{scope.row.useState == 0?'未使用':scope.row.useState == 1?'已使用':''}}
                </template>
            </el-table-column>
            <el-table-column
                prop="backState"
                width="180"
                label="退货状态">
                <template slot-scope="scope">
                    {{scope.row.backState == 0?'未退货':scope.row.backState == 1?'退货中':''}}
                </template>
            </el-table-column>
            <el-table-column
                prop="deliveryTime"
                label="时间">
            </el-table-column>
          </el-table>
      </div>
      <div class="page">
          <el-pagination
            :background="true"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
          <!-- 退货 -->
          <el-dialog
            title="退货申请"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="60%"
            style="text-align: left;"
            >
           <div class="content">
               <ul>
                   <li>设备ID: <span>{{deviceid}}</span></li>
                   <li>设备名称: <span>{{devicename}}</span></li>
                   <li>退货数量: <span>{{devicenum}}</span></li>
                   <li style="width:100%;overflow: hidden;"><span style="float: left;margin-right: 10px;">设备编码:</span> <span class="devicenum" v-for="item in devicecodeList" :key="item">{{item}} <i class="el-icon-circle-close" style="font-size: 20px;margin-left: 10px;margin-right: 5px;" @click="removes(item)"></i></span></li>
               </ul>
               <div class="reason">
                   <span >退货理由:</span>
                   <el-input
                        placeholder="请输入内容"
                        v-model="input"
                        clearable>
                    </el-input>
               </div>
           </div>
            <span slot="footer" class="dialog-footer">
                <el-button  v-preventReClick @click="dialogVisible = false">取 消</el-button>
                <el-button  v-preventReClick type="primary" @click="backgoods()">确 定</el-button>
            </span>
            </el-dialog>
      </div>
  </div>
</template>

<script>
import {clientInventoryDetail,backApply} from '../axios/api'
export default {
    data(){
        return{
            value:'',
            tableData:[],
            total:0,
            page:1,
            currentPage4:1,
            states:0,
            multipleSelection:[],
            dialogVisible:false,
            input:'',
            deviceid:'',
            devicename:'',
            devicenum:'',
            devicecodeList:[],
            devicecode:''
        }
    },
    created(){
        // 从库存管理传过来的 当前进入的设备ID
        console.log(this.$route.params.id)
        this.getdata()
    },
    methods:{
       async search(){
           this.states = 1
           var {data:dt} = await clientInventoryDetail({
               current:1,
               limit:10,
               deviceCoding:this.devicecode,
               useState:this.value,
               deviceId:this.$route.params.id,
               shopId:window.localStorage.getItem('shopId')
           })
           console.log(dt)
           if(dt.code == 200){
               this.page = 1
               this.tableData = dt.data.page.records
                this.total = dt.data.page.total
           }
        },
        async search1(){
           this.states = 1
           var {data:dt} = await clientInventoryDetail({
               current:this.page,
               limit:10,
               deviceCoding:this.devicecode,
               useState:this.value,
               deviceId:this.$route.params.id,
               shopId:window.localStorage.getItem('shopId')
           })
           console.log(dt)
           if(dt.code == 200){
               this.tableData = dt.data.page.records
               this.total = dt.data.page.total
           }
        },
        shopselect(value){
            console.log(value)
            this.shop4snum = value
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.page = val
            if(this.states == 0){
                this.getdata()
            }else{
                this.search1()
            }
            
        },
        async getdata(){
            this.states = 0
            var {data:dt} = await clientInventoryDetail({
                current:this.page,
                limit:10,
                deviceCoding:'',
                useState:'',
                deviceId:this.$route.params.id,
                shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.tableData = dt.data.page.records
                this.total = dt.data.page.total
            }
        },
        handleSelectionChange(val) {
            console.log(val)
            this.multipleSelection = val;
        },
        // 退货
        returns(){
            if(this.multipleSelection.length !== 0){
                 let a = this.multipleSelection.map(item=>{
                    // if(item.useState == 0 && item.backState == 0){
                    //     this.dialogVisible = true
                    //     this.deviceid = item.deviceId
                    //     this.devicename = item.deviceName
                    //     return item
                    // }else{
                    //     this.dialogVisible = false
                    //     this.$message.error('请选择未使用且未退货的的设备')
                    // }
                    if(item.backState == 0 && item.useState == 0){
                        this.dialogVisible = true
                        this.deviceid = item.deviceId
                        this.devicename = item.deviceName
                        return item
                    }
                })
                console.log(a)
                let b = []
                a.forEach(item=>{
                    if(item !== undefined){
                        b.push(item)
                    }
                })
                if(b.length == 0){
                        this.dialogVisible = false
                         this.$message.error('请选择未使用且未退货的的设备')
                         return
                }
                this.devicecodeList = b.map(item=>{
                    return item.deviceCoding
                })
                console.log(this.devicecodeList)
                this.devicenum = b.length
                
            }else{
                this.$message.error('请选择未使用且未退货的的设备')
            }
        },
        selectuse(value){
            console.log(value)
            this.value = value
        },
        removes(item){
            console.log(item,this.devicecodeList)
            for(var i=0;i<this.devicecodeList.length;i++){
                if(this.devicecodeList[i] == item){
                    this.devicecodeList.splice(i,1)
                    this.devicenum = this.devicecodeList.length
                    this.$message.success('移除成功')
                }
            }
        },
        async backgoods(){
            if(this.devicecodeList.length !== 0){
                    var {data:dt} = await backApply({
                    shopId:window.localStorage.getItem('shopId'),
                    deviceCoding:this.devicecodeList.toString(),
                    deviceName:this.devicename,
                    number:this.devicenum,
                    deviceId:this.deviceid,
                    reason:this.input
                })
                console.log(dt)
                if(dt.code == 200){
                    this.dialogVisible = false
                    this.$message.success('申请提交成功')
                    this.getdata()
                }
            }else{
                this.$message.error('请先去选择要退货的设备编码')
            }
        }
    }
}

</script>
<style lang="less" scoped>
.outstock{
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link.el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    }
    .content{
        ul{
            overflow: hidden;
            li{
                float: left;
                width: 33.33%;
                line-height: 40px;
                margin-bottom: 20px;
                .devicenum{
                    padding: 0px 10px;
                    background: #f6f6f6;
                    border-radius: 5px;
                    margin-right: 10px;
                    font-size: 16px;
                    margin-bottom: 20px;
                    display: block;
                    float: left;
                }
            }
            
        }
        .reason{
            overflow: hidden;
            margin-top: 30px;
            span{
                float: left;
                width: 7%;
                height: 50px;
                line-height: 50px;
            }
            .el-input{
                float: left;
                width: 70%;
                margin-top: 5px;
            }
        }
    }
}
</style>